import MarkAsCapturedForm from "./MarkAsCapturedForm.component.jsx";

export default MarkAsCapturedForm;